import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { ReservationRepository } from '../repositories/reservation.respository';

export class RestoreReservationUseCase implements UseCase<any, any> {
    constructor(private readonly repository: ReservationRepository) {}

    execute(): Observable<any> {
        return this.repository.restoreReservation();
    }
}
